import { Airport } from '../models/airport.model';
import { EditToggleService } from '../../shared/services/edit-toggle.service';
import { MatDialog, MatDialogConfig, MatSnackBar } from '@angular/material';
import { EditOverviewComponent } from '../edit-overview/edit-overview.component';
import { EditIslandOverviewComponent } from '../edit-island-overview/edit-island-overview.component';
import { Router } from '@angular/router';
import { SuggestAChangeComponent } from '../../shared/suggest-a-change/suggest-a-change.component';
var OverviewHeaderComponent = /** @class */ (function () {
    function OverviewHeaderComponent(_toggleService, _snackBar, _editAirportOverviewDialog, _editIslandAirportOverviewDialog, _suggestAChangeDialog, _router) {
        var _this = this;
        this._toggleService = _toggleService;
        this._snackBar = _snackBar;
        this._editAirportOverviewDialog = _editAirportOverviewDialog;
        this._editIslandAirportOverviewDialog = _editIslandAirportOverviewDialog;
        this._suggestAChangeDialog = _suggestAChangeDialog;
        this._router = _router;
        this.editModeSet = false;
        this._toggleService.toggleEmitter.subscribe(function (isOn) {
            _this.editModeSet = isOn;
        });
    }
    Object.defineProperty(OverviewHeaderComponent.prototype, "website", {
        get: function () {
            var website = this.airport.website || '';
            if (website.indexOf('http://') >= 0 || website.indexOf('https://') >= 0) {
                return website;
            }
            else {
                return 'http://' + website;
            }
        },
        enumerable: true,
        configurable: true
    });
    OverviewHeaderComponent.prototype.getWebcamCount = function () {
        var webcamCount = this.airport.webcams.length;
        this.airport.businesses.forEach(function (business) {
            business.webcams.forEach(function (businessWebcam) {
                webcamCount++;
            });
        });
        return webcamCount;
    };
    OverviewHeaderComponent.prototype.navigateToWx = function () {
        var tempUrl = this._router.url;
        if (this._router.url.indexOf('#') > 0) {
            tempUrl = this._router.url.substr(0, tempUrl.indexOf('#'));
        }
        this._router.navigate([tempUrl], { fragment: 'wx' });
    };
    Object.defineProperty(OverviewHeaderComponent.prototype, "identifier", {
        get: function () {
            if (this.airport.identifier != null && this.airport.identifier.toUpperCase().startsWith('ZZ')) {
                return '';
            }
            else {
                return '(' + this.airport.identifier + ')';
            }
        },
        enumerable: true,
        configurable: true
    });
    OverviewHeaderComponent.prototype.openEditWebsiteDialog = function () {
        var _this = this;
        var dialogConfig = new MatDialogConfig();
        var ERROR_MSG = 'An error has occurred, please try back later, or call 1-800-USA-AOPA if the error persists.';
        dialogConfig.disableClose = true;
        dialogConfig.autoFocus = true;
        dialogConfig.width = '60%';
        dialogConfig.data = {
            airportID: this.airport.airportId,
            website: this.airport.website
        };
        dialogConfig.width = '60%';
        var dialogRef = this._editAirportOverviewDialog.open(EditOverviewComponent, dialogConfig);
        dialogRef.afterClosed().subscribe(function (isUpdated) {
            if (!isUpdated) {
                return;
            } // required to handle backdrop click.
            if (isUpdated.cancelBtnClicked) {
                return;
            }
            // isUpdated.success will be false if there is an error during any of the api calls.
            if (isUpdated.success) {
                _this.airport.website = isUpdated.website;
                _this._snackBar.open('Website', 'Updated', {
                    duration: 2000
                });
            }
            else {
                _this._snackBar.open(ERROR_MSG, 'Error', {
                    duration: 6000
                });
            }
        });
    };
    OverviewHeaderComponent.prototype.openEditIslandOverviewDialog = function () {
        var _this = this;
        var dialogConfig = new MatDialogConfig();
        var ERROR_MSG = 'An error has occurred, please try back later, or call 1-800-USA-AOPA if the error persists.';
        dialogConfig.disableClose = true;
        dialogConfig.autoFocus = true;
        dialogConfig.width = '60%';
        dialogConfig.data = {
            airport: this.airport
        };
        dialogConfig.width = '60%';
        var dialogRef = this._editIslandAirportOverviewDialog.open(EditIslandOverviewComponent, dialogConfig);
        dialogRef.afterClosed().subscribe(function (isUpdated) {
            if (!isUpdated) {
                return;
            } // required to handle backdrop click.
            if (isUpdated.cancelBtnClicked) {
                return;
            }
            // isUpdated.success will be false if there is an error during any of the api calls.
            if (isUpdated.success) {
                _this.airport = isUpdated.airport;
                _this._snackBar.open('Airport Overview', 'Updated', {
                    duration: 2000
                });
            }
            else {
                _this._snackBar.open(ERROR_MSG, 'Error', {
                    duration: 6000
                });
            }
        });
    };
    OverviewHeaderComponent.prototype.openSuggestAChangeDialog = function () {
        var _this = this;
        var dialogConfig = new MatDialogConfig();
        var ERROR_MSG = 'An error has occurred, please try back later, or call 1-800-USA-AOPA if the error persists.';
        dialogConfig.disableClose = true;
        dialogConfig.autoFocus = true;
        dialogConfig.width = '35%';
        dialogConfig.data = {
            airportID: this.airport.airportId,
            airportAbbrev: this.airport.faaId != null ? this.airport.faaId : this.airport.icaoId
        };
        var dialogRef = this._suggestAChangeDialog.open(SuggestAChangeComponent, dialogConfig);
        dialogRef.afterClosed().subscribe(function (isUpdated) {
            if (!isUpdated) {
                return;
            } // required to handle backdrop click.
            if (isUpdated.cancelBtnClicked) {
                return;
            }
            // isUpdated.success will be false if there is an error during any of the api calls.
            if (isUpdated.success) {
                _this._snackBar.open('The information you have provided has been forwarded to the AOPA Airport Directory team and ' +
                    'will be reviewed as soon as possible. Thank you!', 'Success', {
                    duration: 6000
                });
            }
            else {
                _this._snackBar.open(ERROR_MSG, 'Error', {
                    duration: 6000
                });
            }
        });
    };
    return OverviewHeaderComponent;
}());
export { OverviewHeaderComponent };
